import useActivationObject from '../../../providers/ActivationObjectProvider/hooks/useActivationObject'
import { Step2Props, useStep2Props } from '../types'
import useStep2Form from './useStep2.form'
import useStep2FormOptions from './useStep2.form.options'
import useStep2FormConditions from './useStep2.form.conditions'
import useStep2FormMapOptions from './useStep2.form.map'
import useStep2FormStreet from './useStep2.form.street'

const useStep2 = (props: useStep2Props): Step2Props => {
    const { data: activationObject, isUpdating } = useActivationObject()
    const formProps = useStep2Form(activationObject)
    const options = useStep2FormOptions(formProps.form)
    const conditionsProps = useStep2FormConditions(formProps.form, options, activationObject)
    const mapProps = useStep2FormMapOptions(formProps.form, activationObject)
    const streetSugestionsProps = useStep2FormStreet(formProps.form)
    return {
        ...props,
        activationObject,
        form: formProps,
        options: options,
        conditions: conditionsProps,
        map: mapProps,
        streetSugestions: streetSugestionsProps,
        isUpdating,
    }
}

export default useStep2
